import { useEffect, useRef, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

const STATUS = { idle: "", draft: "Rascunho local…", saving: "A gravar…", saved: "Gravado", error: "Erro ao gravar" };

export const NotasPedido = ({ pedidoId, notas, disabled }) => {
  const key = `atlas_notas_${pedidoId}`;
  const [txt, setTxt] = useState(() => localStorage.getItem(key) ?? notas ?? "");
  const [status, setStatus] = useState(localStorage.getItem(key) !== null ? "draft" : "idle");
  const saved = useRef(notas ?? "");
  const timer = useRef(null);

  const save = async (value) => {
    clearTimeout(timer.current);
    if (value === saved.current) { localStorage.removeItem(key); return; }
    setStatus("saving");
    try {
      await api.put(`/atendimentos/${pedidoId}`, { notas: value });
      saved.current = value;
      localStorage.removeItem(key);
      setStatus("saved");
    } catch (err) { setStatus("error"); toast.error(apiError(err)); }
  };

  useEffect(() => () => clearTimeout(timer.current), []);

  const onChange = (e) => {
    const v = e.target.value;
    setTxt(v);
    localStorage.setItem(key, v);
    setStatus("draft");
    clearTimeout(timer.current);
    timer.current = setTimeout(() => save(v), 3000);
  };

  return (
    <div className="px-5 py-3 border-t border-slate-100" data-testid="notas-pedido">
      <div className="flex items-center justify-between mb-1">
        <span className="text-[10px] uppercase text-slate-400 font-semibold">Notas do pedido</span>
        <span className={`text-[10px] ${status === "error" ? "text-rose-500" : "text-slate-400"}`} data-testid="notas-status">{STATUS[status]}</span>
      </div>
      <Textarea value={txt} onChange={onChange} onBlur={() => save(txt)} disabled={disabled} rows={3}
        placeholder="Notas internas (gravadas automaticamente)" className="text-xs" data-testid="notas-textarea" />
    </div>
  );
};
